import * as Sentry from '@sentry/react';

const isProd = process.env.VITE_ENVIRONMENT === 'production' || process.env.NEXT_PUBLIC_ENVIRONMENT === 'production';
const isSentryEnabled = process.env.VITE_SENTRY_ENABLED === 'true' || process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true';

if (isProd || isSentryEnabled) {
  Sentry.init({
    dsn: 'https://fad9e46a697148f0019542ddbd0611c7@o419918.ingest.us.sentry.io/4509446985154560',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.3,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    release: process.env.VITE_APP_VERSION,
  });
}

export { Sentry };
